export default {
  changeLinkColor: Styles.color.grey.one,
  phoneNumberInformationColor: Styles.color.grey.three,
};
